<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgement</h1>
<p style="text-indent:00em;">This book is blessed with a wealth of inputs and insights from other people, from whose great expertise and authority I have borrowed. Oliver Burkeman’s regular column in <em>The Guardian</em>—‘This column will change your life’—was a huge source of inspiration, as was his book <em>The Antidote: Happiness for people who can’t stand positive thinking</em>.</p><br/>
<p style="text-indent:00em;">The influencing academic sources are obvious—Richard Dawkins’ <em>The Selfish Gene</em> and Susan Blackmore’s <em>The Meme Machine</em> are key texts. The historical background on the Reivers comes from a number of sources, including Georg MacDonald Fraser’s <em>The Steel Bonnets: Story of the Anglo-Scottish Border Reivers</em>; Keith Durham’s <em>The Border Reivers: Men at Arms</em>; Michael Hornsby-Smith’s <em>Catholics in England</em> and Alistair Moffat’s <em>The Reivers: The Story of the Border Reivers</em>.</p><br/>
<p style="text-indent:00em;">The history of Liverpool’s often fraught dance with authority is supported by a number of texts, including John Smith’s article in the <em>History Workshop Journal</em>, 1984 and the series of articles on Liverpool strikes provided by <em>catalystmedia.org.uk</em>. Every effort has been made in the book to quote citations from sources. A humble apology is offered for any citation omissions.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1cc374ea